import nescafe from "./img2/Nescafe.jpeg";
import './Sponsorship.css';
import ola from "./img2/ola.jpeg";
import plum from "./img2/plum.jpeg";
import topntown from "./img2/topntown.jpeg";
import coding from "./img2/CodingNinjas.jpeg";
import jockey from "./img2/Jockey.jpeg";
import reliance from "./img2/Reliance.jpeg";
import patanjali from "./img2/patanjali.jpeg";
import bob from "./img2/Bob.jpeg";
import ongc from "./img2/ongc.jpeg";
import sting from "./img2/sting.jpeg";
import honda from "./img2/honda.jpeg";
import sbi from "./img2/sbi.jpeg";
import indianoil from "./img2/IndianOil.jpeg";
import CanaraBank from "./img2/CanaraBank.jpeg";
import whitefox from "./img2/Whitefox.jpeg";
import chalobus from "./img2/ChaloBus.jpeg";
import cafecoffeeday from "./img2/CafeCoffeeDay.jpeg";
import botlab from "./img2/Botlab.jpeg";
import gfg from "./img2/GFG.jpeg";
import guvi from "./img2/guvi.jpeg";
import ktm from "./img2/KTM.jpeg";
import mlh from "./img2/MLH.jpeg";
import uber from "./img2/uber.jpeg";
import unstop from "./img2/Unstop.jpeg";
import lost from "./img2/LostStories.jpeg";
import hp from "./img2/hp.jpeg";
import civil from "./img2/civil.jpeg";
import amul from "./img2/amul.jpeg";

const sponsors = [
  // Row 1
  ola, nescafe, plum, topntown, coding, jockey, reliance, patanjali, bob, sbi, indianoil, ongc,
  // Row 2
  sting, honda, CanaraBank, whitefox, chalobus, ktm, mlh, guvi, gfg, amul, uber, unstop,
  // Row 3
  lost, civil, botlab, cafecoffeeday, hp
];

function App() {
  return (
    <div className="sponsors-section">
      <div className="sp-container">
        {sponsors.map((src, index) => (
          <img 
            key={index}
            src={src}
            alt={`Sponsor ${index + 1}`}
            className="sponsor-logo"
          />
        ))}
      </div>
    </div>
  );
}

export default App;
